import { useState } from 'react';
import { ITrainersData, ITrainersTool } from '@/types/trainers';
import { getNormalizedDetections, getNormalizedImages } from '@/utils/trainers';

import ErrorMessage from '@/components/ui/trainers/shared/ErrorMessage';
import ImageCarousel from '@/components/ui/trainers/ImageCarousel';

interface Props {
  data?: ITrainersData;
  tool?: ITrainersTool;
}

const MergeTrainer: React.FC<Props> = ({ data, tool }) => {
  const {
    leaseId,
    candidateFeatures = {},
    landmarkAssets,
  } = data?.content || {};

  const labels: { [key: string]: string } = {};
  Object.keys(candidateFeatures).forEach(key => {
    const label = candidateFeatures[key].label;
    labels[label] = label;
  });

  const titles = Object.keys(labels);
  const titleInfo: string =
    `*${titles.shift()?.replaceAll('-', ' ') || 'object'}*` || '';
  titles.forEach(title => {
    titleInfo.concat(' or ', title);
  });

  const SVGOverlay = tool?.args?.svgOverlay;

  const [contentHeight, setContentHeight] = useState(0);

  const landmarkImages = getNormalizedImages(
    landmarkAssets?.frames,
    landmarkAssets?.closeFrames,
  );
  const landmarkDetections = getNormalizedDetections(
    landmarkAssets?.frames,
    landmarkAssets?.closeFrames,
    landmarkAssets?.detectionsByFrame,
  );

  const numCarousels = Object.keys(candidateFeatures).length + 1;
  const carouselWidth = 100 / numCarousels;

  return (
    <div className="flex size-full flex-col">
      {data?.error ? (
        <ErrorMessage error={data.error} />
      ) : (
        <>
          <div
            className="relative flex grow items-center overflow-hidden"
            // lets give some extra space (50px) for the carousel controls
            style={{ height: contentHeight + 50 }}>
            <div className="flex w-full items-center justify-start overflow-x-auto">
              {candidateFeatures &&
                Object.entries(candidateFeatures).map(([key, feature]) => {
                  const candidateImages = getNormalizedImages(
                    feature?.frames,
                    feature?.closeFrames,
                  );
                  const candidateDetections = getNormalizedDetections(
                    feature?.frames,
                    feature?.closeFrames,
                    feature?.detectionsByFrame,
                  );
                  return (
                    <div key={key} style={{ width: `${carouselWidth}%` }}>
                      <ImageCarousel
                        key={`${leaseId}-candidate-${key}`}
                        images={candidateImages}
                        detections={candidateDetections}
                        SVGOverlay={SVGOverlay}
                        startWithIndex="largestDetection"
                        onImageLoaded={setContentHeight}
                      />
                    </div>
                  );
                })}
              <div style={{ width: `${carouselWidth}%` }}>
                <ImageCarousel
                  key={`${leaseId}-landmark`}
                  images={landmarkImages}
                  detections={landmarkDetections}
                  startWithIndex="largestDetection"
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default MergeTrainer;
